import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const LoadingScreen = () => (
  <div className="min-h-screen flex items-center justify-center bg-sp-dark" data-testid="auth-loading">
    <div className="flex flex-col items-center gap-4">
      <div className="h-10 w-10 rounded-full border-2 border-white/20 border-t-white animate-spin" />
      <span className="font-mono text-xs uppercase tracking-[0.2em] text-white/50">Verifying access</span>
    </div>
  </div>
);

export const ProtectedRoute = ({ children, requireAdmin = false, redirectTo = "/login" }) => {
  const { user, loading } = useAuth();

  if (loading || user === null) return <LoadingScreen />;
  if (!user) return <Navigate to={redirectTo} replace />;
  if (requireAdmin && user.role !== "admin") return <Navigate to="/" replace />;

  return children;
};

export default ProtectedRoute;
